import classNames from 'classnames';
import type { PropsWithChildren } from 'react';

import './heading.scss';

interface Props extends PropsWithChildren {
  disableMarginTop?: boolean;
  subpager?: boolean;
}

export const Heading = ({ children, disableMarginTop = false, subpager = false }: Props) => {
  if (subpager) {
    return (
      <h5 className={classNames('heading-subpager-WUESX', disableMarginTop && 'disable-margin-top')}>{children}</h5>
    );
  }

  return <h3 className={classNames('heading-SWJON', disableMarginTop && 'disable-margin-top')}>{children}</h3>;
};
